import { TriangleDownIcon, XCircleFillIcon } from '@primer/octicons-react';
import { Box, Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { clubApi } from '../../api/clubApi';
import { RootState } from '../../state/reducers';

type MeetingItem = {
    id: number;
    name: string;
};

type ComboboxMeetingProps = {
    value: number;
    onValueChanged: (id: number, data?: MeetingItem) => void;
    isShowClearBtn?: boolean;
    placeholder?: string;
};

const ComboboxClubSchedule = (props: ComboboxMeetingProps) => {
    const [meetings, setMeetings] = useState<MeetingItem[]>([]);
    const [filter, setFilter] = useState('');
    const [open, setOpen] = useState(false);
    const dm_truongs = useSelector((state: RootState) => state.auth.user_info?.campus);

    useEffect(() => {
        handleGetMeetings();
    }, []);

    const handleGetMeetings = async () => {
        const res = await clubApi.scheduleSelect();
        if (res.is_success) {
            setMeetings(
                            (res.data as any[]).filter(x =>
                                dm_truongs?.some(t => t.id === x.dm_truong_id)
                            )
                        );
        }
    };

    const dataSource = useMemo(() => {
        return meetings.map(x => ({
            id: x.id,
            text: x.name
        }));
    }, [meetings]);

    const filteredData = useMemo(() => {
        return dataSource.filter(item =>
            item.text.toLowerCase().includes(filter.toLowerCase())
        );
    }, [dataSource, filter]);

    const selectedData = useMemo(() => {
        return dataSource.find(x => x.id === props.value);
    }, [props.value, dataSource]);

    return (
        <SelectPanel
            renderAnchor={({ children, ...anchorProps }) => (
                <Button
                    trailingAction={TriangleDownIcon}
                    {...anchorProps}
                    sx={{ maxWidth: 300 }}
                >
                    <p style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}>
                        {children || props.placeholder || "Chọn lịch học"}
                    </p>
                </Button>
            )}
            title={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box sx={{ flex: 1 }}>
                        {props.placeholder || "Chọn lịch học"}
                    </Box>

                    {props.isShowClearBtn && (props.value ?? 0) > 0 && (
                        <Button
                            trailingVisual={XCircleFillIcon}
                            variant="invisible"
                            sx={{ color: "danger.emphasis" }}
                            onClick={() => props.onValueChanged(0)}
                        >
                            Bỏ chọn
                        </Button>
                    )}
                </Box>
            }
            placeholderText="Tìm kiếm..."
            open={open}
            onOpenChange={setOpen}
            items={filteredData}
            selected={selectedData}
            onSelectedChange={(item: any) => {
                if (item) {
                    const meeting = meetings.find(x => x.id === item.id);
                    props.onValueChanged(item.id, meeting);
                }
            }}
            onFilterChange={setFilter}
            showItemDividers
            overlayProps={{ width: 'medium', height: 'medium' }}
        />
    );
};

export default ComboboxClubSchedule;